/*
*
* This is a demo of the Disney Plus User Interface
* rebuilt in ReactJS by Brian McCracken
* If you see this code or file elsewhere, please let me
* know at https://www.brianmccracken.com
*
* Naturally, all of the images and characters portayed in
* this demo project belong to Disney. :)
*
*/

import React from 'react'
import styled from 'styled-components'

function Viewers() {
    return (
        <Container>
            <DisneyWrap>
                <img src="/images/viewers-disney.png" />
            </DisneyWrap>
            <PixarWrap>
                <img src="/images/viewers-pixar.png" />
            </PixarWrap>
            <MarvelWrap>
                <img src="/images/viewers-marvel.png" />
            </MarvelWrap>
            <StarwarsWrap>
                <img src="/images/viewers-starwars.png" />
            </StarwarsWrap>
            <NatgeoWrap>
                <img src="/images/viewers-national.png" />
            </NatgeoWrap>
        </Container>
    )
}

export default Viewers

const Container = styled.div`
    margin-top: 30px;
    padding: 30px 0px 26px;
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    grid-gap: 25px;  

`
const DisneyWrap = styled.div`

    border: 3px solid rgba(249, 249, 249, 0.1);
    border-radius: 10px;
    box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
    rgb(0 0 0 / 73%) 0px 16px 10px -10px;
    cursor: pointer;
    transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &:hover {
        box-shadow: rgb(0 0 0 / 80%) 0px 40px 55px -16px,
        transform: scale(1.3);
        border-color: rgba(249, 249, 249, 0.8);
        background-image: url("/images/disney.gif");
        background-position: center center;
        background-repeat: no-repeat;
        background-image-size: cover;
        background-size: 100% 100%;
    }

`

const PixarWrap = styled(DisneyWrap)`

    &:hover {
        background-image: url("/images/pixar.gif");
    }

`

const MarvelWrap = styled(DisneyWrap)`

    &:hover {
        background-image: url("/images/marvel.gif");
    }

`

const StarwarsWrap = styled(DisneyWrap)`

    &:hover {
        background-image: url("/images/star-wars.gif");
    }

`

const NatgeoWrap = styled(DisneyWrap)`

    &:hover {
        background-image: url("/images/nat-geo.gif");
    }

`